export default () => {

    const text = `
 ██████╗  ██████╗ ███╗   ██╗ ██████╗     ██████╗  █████╗  ██████╗     ████████╗███████╗ ██████╗██╗  ██╗
██╔════╝ ██╔═══██╗████╗  ██║██╔════╝     ██╔══██╗██╔══██╗██╔═══██╗    ╚══██╔══╝██╔════╝██╔════╝██║  ██║
██║  ███╗██║   ██║██╔██╗ ██║██║  ███╗    ██████╔╝███████║██║   ██║       ██║   █████╗  ██║     ███████║
██║   ██║██║   ██║██║╚██╗██║██║   ██║    ██╔══██╗██╔══██║██║   ██║       ██║   ██╔══╝  ██║     ██╔══██║
╚██████╔╝╚██████╔╝██║ ╚████║╚██████╔╝    ██████╔╝██║  ██║╚██████╔╝       ██║   ███████╗╚██████╗██║  ██║
 ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝     ╚═════╝ ╚═╝  ╚═╝ ╚═════╝        ╚═╝   ╚══════╝ ╚═════╝╚═╝  ╚═╝
\t\t\t\t\t\t\t\t\tVERSION:${APP_VERSION}.${GIT_HASH}/${GIT_BRANCH}
\t\t\t\t\t\t\t\t\tBUILD DATE:${BUILD_DATE}`
    console.log(`%c${text}`, 'color:#fc4d50')
}